export const GETTING_STARTED_FILE_NAME = 'Getting Started.md';

/**
 * Seeded into every newly created workspace so first-time users land on a
 * concrete guide instead of an empty notes table.
 */
export const GETTING_STARTED_MARKDOWN = `# Getting Started

Welcome to Typo Notes, a Markdown notes app. Your notes are kept in plain \`.md\` files, which can be stored in the browser, in a folder on your computer (right now only Chromium is supported), or synced via the cloud.

This note will help guide you through Typo Notes and how it works. Edit it, rename it, or delete it whenever you like.

## Notes, Folders and Workspaces

Notes are Markdown files. Folders group them in the file tree. You can Rename, Move, Delete, Clone, and Star notes from the sidebar, top bar, or Commands.

A Workspace is a collection of notes (and folders) that live together. There are three kinds:

| Type | Where Your Notes Are | What It's Good for |
| --- | --- | --- |
| **Browser** | Your browser's cache | Quick or ephemeral notes. Clearing your browser's history/ cache will erase them. |
| **Native File System** | A folder on your computer of your choosing | Notes you want to keep locally or open in other editors |
| **Cloud** | Synced through Typo Notes | Sharing, Invites, and working on notes with others |

You can create another workspace anytime from the sidebar or inside Commands (more on that later).

## Writing in the Editor

Typo Notes uses a WYSIWYG Markdown editor. You can start typing anywhere and your work will autosave.

Press \`/\` for the slash menu from which Headings, Lists, Todos, Code, Tables, and more can be created. Ctrl + \\\\ (⌘ + \\\\ on Mac) can be used to toggle the Sidebar on and off.

Type \`[[\` to create a Wiki Link to another note (whether it exists already or not!) Linked mentions for the current note appear at the bottom of the editor when other notes point to the current one.

Assets can be created by dropping Images/ other File Attachments, or even pasting Direct Links from Dropbox or pCloud's Public Folder.

## Search and Commands

Commands can be used to quickly move around Typo Notes and change settings, and can be accessed from the bottom of the sidebar, or by hitting Ctrl+Shift+. (or ⌘+Shift+. on Mac).

Notes can be easily Searched by name using Ctrl+K (⌘+K on Mac), with fine grained keyword searches planned.

## Settings, Import, and Recovery

The app's Settings can be opened from the sidebar or via Command.

**General** contains controls for the app's Theme, Fonts, and other related preferences.

**Workspaces** allows you to manage your workspaces easily

**Import/ Export** allows you to bring in Markdown files, folders, or even a zip. You can also export a zip of any of your workspaces, as your work is always yours. Cloud Workspaces can also be synced with Github, allowing for external changes to be made to notes.

**Recovery** stores automatic snapshots of your notes, allowing you to recover lost data if something goes wrong.

## Cloud Collaboration

When working in a cloud workspace, you can collaborate and share your notes with others.

Invites allow you to share single note Reader Links with outside parties, or invite editors to work on a single note or entire workspace with you.

All of this is controlled from the Share Panel, which displays your per-note grants and Reader Links (which require no account to access).

Any note or folder of notes can be set to Private, at which point it is hidden from anyone else with access to the workspace.

Akin to other collaborative writing platforms, Typo Notes supports Live Multiplayer editing via YJS and CRDTs. User cursors and presence avatars will enable you to see who is working where.

Comments can be left anywhere by highlighting text and selecting the comment option or via Ctrl+Alt+M (⌘⌥M on Mac).

Happy writing!
`;
